app.directive('sgItemTile', function($window, throttle, $log) {
    return {
        restrict: 'C',
        link: function($scope, $element) {
            var baseSize = 250;
            var $scaleTarget = $element.find('.sg-item-tile-scalable');

            var setScaleOfTarget = function() {
                var currentMultiplier = $element[0].offsetWidth / baseSize;
                $scaleTarget.css('transform', 'scale(' + currentMultiplier + ')').removeClass('invisible');
            };
            setScaleOfTarget();

            addResizeListener($element[0], setScaleOfTarget);

            $scope.$on('$destroy', function() {
                removeResizeListener($element[0], setScaleOfTarget);
            });
        }
    };
});